import { render } from "./BlogArticleShortView.vue?vue&type=template&id=cde22534&scoped=true"
import script from "./BlogArticleShortView.vue?vue&type=script&lang=js"
export * from "./BlogArticleShortView.vue?vue&type=script&lang=js"

import "./BlogArticleShortView.vue?vue&type=style&index=0&id=cde22534&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cde22534"]])

export default __exports__